import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SurveyScore } from '@ps/survey-utils';

import {
  ComputeScoreParams,
  SurveyScoreApi,
} from '../../api/survey-score/survey-score.api';

@Injectable({ providedIn: 'root' })
export class SurveyScoreService {
  private readonly _api = inject(SurveyScoreApi);

  public computeScore(
    surveyId: number,
    params: ComputeScoreParams,
  ): Observable<SurveyScore> {
    return this._api.computeScore(surveyId, params);
  }
}
